import React, { useCallback, useEffect, useState, useReducer } from "react";
import "./PropertieMPIGaugeChartComponent";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { GetMpiGaugeChartDataAPI } from "../../../../../../Services";
import { GaugeChart } from "./GaugeChart";

export const PropertieMPIGaugeChartComponent = ({
  unitId,  
  marketComparison,
  activeData,
  operationType,
  parentTranslationPath,
  translationPath = '',
}) => {
  const { t } = useTranslation(parentTranslationPath, "Shared");


  const reducer = (select, action) => {
    if (action.id !== "edit") return { ...select, [action.id]: action.value };
    if (action.id === "edit") {
      return {
        ...action.value,
      };
    }
  };
  const [defaultState, setDefaultState] = useState({
    minPrice: null,
    maxPrice: null,
    medianPrice: null,
    medianPricePerSqft: null,
    psiPrice: null,
    noMPIDataFoundForTheUnit: null,
  });
  const [state, setState] = useReducer(reducer, {
    ...defaultState,
  });

  const GetUnitMpiGaugeChartInfo = useCallback(async () => {
    const rs = await GetMpiGaugeChartDataAPI({
      unitId: unitId,
      operationType: operationType,
    });
    if (!(rs && rs.status && rs.status !== 200)) {
      if (rs)
        setState({
          id: "edit",
          value: { ...rs, noMPIDataFoundForTheUnit: null },
        });
    } else if (rs && rs.status && rs.status === 400) {
      setState({ id: "noMPIDataFoundForTheUnit", value: rs?.data });
    } else setState({ id: "edit", value: defaultState });
  });

  useEffect(() => {
    if (unitId !== undefined && operationType !== undefined)
      GetUnitMpiGaugeChartInfo();
  }, [unitId, operationType]);

  const shouldShowNoData =
    !activeData?.builtup_area_sqft ||
    activeData.builtup_area_sqft <= 0 ||
    activeData.medianPricePerSqft <= 0;

  return (
    <div className="w-100 mb-3">
      { shouldShowNoData && (
        <div className="px-2">
          <span className="px-2 fw-bold">{t(`${translationPath}mpi`)}</span>
          <span className="fw-bold c-primary">
            {t(`${translationPath}no-mpi-data-found-for-the-unit`)}
          </span>
        </div>
      ) || shouldShowNoData && (
        <div className="text-center d-flex flex-column justify-content-center align-items-center" style={{
          height: "100%",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          width: "100%",
        }}>
          <svg
            version="1.1"
            id="Uploaded_to_svgrepo_com"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="102px"
            height="102px"
            viewBox="0 0 32 32"
            xmlSpace="preserve"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <style type="text/css">{`
                  .hatch_een { fill: #265AA5; }
                  .hatch_twee { fill: #ff0000; }
                  .st0 { fill: #333B3A; }
                `}</style>
              <g>
                <path
                  className="hatch_twee"
                  d="M29.135,11.559c0.127,0.351,0.244,0.701,0.345,1.064l-8.574,8.575l-0.707-0.707L29.135,11.559z M18.198,18.491l0.707,0.707l9.434-9.434c-0.161-0.306-0.334-0.608-0.516-0.9L18.198,18.491z M16.198,16.491l0.707,0.707 l9.842-9.842c-0.211-0.259-0.431-0.513-0.66-0.756L16.198,16.491z M22.198,22.491l0.707,0.707l7.089-7.088 c-0.012-0.446-0.045-0.888-0.096-1.324L22.198,22.491z M24.198,24.491l0.707,0.707l4.466-4.465 c0.184-0.598,0.326-1.221,0.431-1.849L24.198,24.491z M22.366,3.738c-0.309-0.166-0.631-0.319-0.952-0.462L16,8.689v1.414 L22.366,3.738z M19.523,2.581c-0.373-0.107-0.757-0.201-1.142-0.278L16,4.689v1.414L19.523,2.581z M24.757,5.35 c-0.259-0.214-0.527-0.423-0.801-0.619L16,12.689v1.414L24.757,5.35z"
                ></path>
                <path
                  className="hatch_een"
                  d="M15.5,1C6.953,1,0,7.953,0,16.5C0,25.047,6.953,32,15.5,32C24.047,32,31,25.047,31,16.5 C31,7.953,24.047,1,15.5,1z M30,16.5c0,3.824-1.492,7.292-3.91,9.883L16,16.293V2.025C23.775,2.291,30,8.661,30,16.5z M1,16.5 C1,8.661,7.225,2.291,15,2.025V16.5c0,0.133,0.053,0.26,0.146,0.354L25.383,27.09C22.792,29.508,19.324,31,15.5,31 C7.492,31,1,24.508,1,16.5z"
                ></path>
              </g>
            </g>
          </svg>
          <p style={{
            marginTop: "16px",
            fontSize: "16px",
            fontWeight: "900",
            color: "#555",
            textAlign: "center",
            alignItems: "center",
            display: "flex",
          }}>
            {t(`${translationPath}no-mpi-data-found-for-the-unit`)}
          </p>
        </div>
      ) || (
        <div className="d-flex GaugeChart">
          <GaugeChart
            activeData={activeData}
            minPrice={state?.minPrice || 0}
            maxPrice={state?.maxPrice}
            medianPricePerSqft={state?.medianPricePerSqft || 0}
            medianPrice={state?.medianPricePerSqft * activeData.builtup_area_sqft || 0}
            marketComparison={marketComparison}
            psiPrice={state?.psiPrice || 0}
            translationPath={translationPath}
            parentTranslationPath={parentTranslationPath}
          />
        </div>
      )}
    </div>
  );
};
